import { render, staticRenderFns } from "./VideosUploadForm.vue?vue&type=template&id=52e72288&scoped=true"
import script from "./VideosUploadForm.vue?vue&type=script&lang=ts"
export * from "./VideosUploadForm.vue?vue&type=script&lang=ts"
import style0 from "./VideosUploadForm.vue?vue&type=style&index=0&id=52e72288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e72288",
  null
  
)

export default component.exports